import { jsxs as v, jsx as s } from "react/jsx-runtime";
import { c as b } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { forwardRef as m } from "react";
const h = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12"
}, p = ({
  size: t = "md",
  className: i,
  ...o
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: b("animate-spin text-current", h[t], i),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "status",
    "aria-label": "Loading",
    ...o,
    children: [
      /* @__PURE__ */ s("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
      /* @__PURE__ */ s("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })
    ]
  }
), y = {
  primary: [
    "bg-primary text-primary-foreground",
    "hover:bg-primary-hover",
    "shadow-sm hover:shadow-md",
    "focus-visible:ring-primary"
  ].join(" "),
  secondary: [
    "bg-secondary text-secondary-foreground",
    "hover:bg-secondary-hover",
    "shadow-xs hover:shadow-sm",
    "focus-visible:ring-ring"
  ].join(" "),
  outline: [
    "border border-border bg-transparent text-foreground",
    "hover:bg-surface-secondary hover:border-border-subtle",
    "focus-visible:ring-ring"
  ].join(" "),
  ghost: [
    "bg-transparent text-foreground",
    "hover:bg-surface-secondary",
    "focus-visible:ring-ring"
  ].join(" "),
  danger: [
    "bg-destructive text-destructive-foreground",
    "hover:bg-destructive-hover",
    "shadow-sm hover:shadow-md",
    "focus-visible:ring-destructive"
  ].join(" "),
  destructive: [
    "bg-destructive text-destructive-foreground",
    "hover:bg-destructive-hover",
    "shadow-sm hover:shadow-md",
    "focus-visible:ring-destructive"
  ].join(" "),
  link: [
    "bg-transparent text-primary underline-offset-4",
    "hover:underline",
    "focus-visible:ring-primary",
    "shadow-none px-0 h-auto"
  ].join(" ")
}, x = {
  sm: "h-8 px-[calc(var(--density-padding)*1.25)] text-xs",
  md: "h-9 px-[calc(var(--density-padding)*1.5)] text-sm",
  lg: "h-11 px-[calc(var(--density-padding)*1.75)] text-base"
}, C = ({
  children: t,
  className: i,
  variant: o = "primary",
  size: a = "md",
  isLoading: e = !1,
  leftIcon: d,
  rightIcon: r,
  disabled: n,
  as: c,
  pressable: l = !0,
  pill: u = !1,
  ...g
}) => {
  const f = c || "button";
  return /* @__PURE__ */ v(
    f,
    {
      className: b(
        "inline-flex items-center justify-center gap-x-[var(--density-gap)] font-medium",
        u ? "rounded-[var(--shape-radius-full)]" : "rounded-[var(--shape-radius-md)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
        "disabled:pointer-events-none disabled:opacity-50",
        "transition-all duration-fast ease-smooth",
        l && "active:scale-press",
        y[o],
        o !== "link" && x[a],
        i
      ),
      disabled: f === "button" ? n || e : void 0,
      ...g,
      children: [
        e && /* @__PURE__ */ s(p, { size: "sm" }),
        !e && d,
        t,
        !e && r
      ]
    }
  );
}, w = m(({
  className: t,
  hasError: i,
  variant: o = "default",
  expandOnFocus: a = !1,
  leftElement: e,
  rightElement: d,
  ...r
}, n) => {
  const c = {
    // Default - balanced, modern input
    default: [
      "bg-card text-foreground border-border/80",
      "shadow-sm",
      "focus-visible:border-primary/80 focus-visible:ring-primary/20"
    ].join(" "),
    // Glass - soft translucent surface
    glass: [
      "bg-surface-glass/80 backdrop-blur-md text-foreground",
      "border-border/70",
      "shadow-sm",
      "focus-visible:border-primary/70 focus-visible:ring-primary/20 focus-visible:bg-surface-glass"
    ].join(" "),
    // Filled - solid panel-like input
    filled: [
      "bg-surface-secondary text-foreground",
      "border-border/80",
      "shadow-none",
      "focus-visible:border-primary/70 focus-visible:ring-primary/15 focus-visible:bg-surface-secondary/80"
    ].join(" ")
  }, l = !!e, u = !!d;
  return l || u ? /* @__PURE__ */ v("div", { className: "relative flex items-center", children: [
    e && /* @__PURE__ */ s("div", { className: "absolute left-[calc(var(--density-padding)*0.75)] flex items-center pointer-events-none text-muted-foreground", children: e }),
    /* @__PURE__ */ s(
      "input",
      {
        ref: n,
        className: b(
          // Base styles
          "block h-11 w-full rounded-[var(--shape-radius-xl)] border px-[calc(var(--density-padding)*1.05)] py-[calc(var(--density-padding)*0.72)]",
          // Padding adjustments for icons
          l && "pl-[calc(var(--density-padding)*2.5)]",
          u && "pr-[calc(var(--density-padding)*2.5)]",
          // Placeholder
          "placeholder:text-muted-foreground/85",
          // Focus state
          "focus-visible:outline-none focus-visible:ring-4",
          // Modern transitions
          "transition-[border-color,box-shadow,background-color,color,transform] duration-fast ease-smooth",
          // Text alignment
          "text-start text-sm",
          // Expand on focus (for search bars)
          a && "focus-visible:scale-[1.01]",
          // Variant styles
          c[o],
          // Error state
          i && "border-destructive/80 focus-visible:border-destructive focus-visible:ring-destructive/20 text-foreground placeholder:text-destructive/60",
          // Disabled state
          r.disabled && "bg-muted/35 text-muted-foreground border-border/70 cursor-not-allowed opacity-80 shadow-none",
          // ReadOnly state
          r.readOnly && "cursor-default bg-surface-secondary/70 focus-visible:border-border/80 focus-visible:ring-border/20",
          t
        ),
        ...r
      }
    ),
    d && /* @__PURE__ */ s("div", { className: "absolute right-[calc(var(--density-padding)*0.75)] flex items-center text-muted-foreground", children: d })
  ] }) : /* @__PURE__ */ s(
    "input",
    {
      ref: n,
      className: b(
        // Base styles
        "block h-11 w-full rounded-[var(--shape-radius-xl)] border px-[calc(var(--density-padding)*1.05)] py-[calc(var(--density-padding)*0.72)]",
        // Placeholder
        "placeholder:text-muted-foreground/85",
        // Focus state
        "focus-visible:outline-none focus-visible:ring-4",
        // Modern transitions
        "transition-[border-color,box-shadow,background-color,color,transform] duration-fast ease-smooth",
        // Text alignment
        "text-start text-sm",
        // Expand on focus (for search bars)
        a && "focus-visible:scale-[1.01]",
        // Variant styles
        c[o],
        // Error state
        i && "border-destructive/80 focus-visible:border-destructive focus-visible:ring-destructive/20 text-foreground placeholder:text-destructive/60",
        // Disabled state
        r.disabled && "bg-muted/35 text-muted-foreground border-border/70 cursor-not-allowed opacity-80 shadow-none",
        // ReadOnly state
        r.readOnly && "cursor-default bg-surface-secondary/70 focus-visible:border-border/80 focus-visible:ring-border/20",
        t
      ),
      ...r
    }
  );
});
w.displayName = "Input";
export {
  C as B,
  w as I,
  p as S
};
